import React from 'react';
import HeaderATS from './HeaderAts';
import FooterAts from './FooterAts';
import data from './data';

const faqs = data.faqs;

const FAQ = () => {
    return (
    <div className="page">
        <HeaderATS />

      <div className="bg-white">
      <div className="mx-auto max-w-7xl divide-y divide-gray-900/10 px-6 py-14 sm:py-24 lg:px-8 lg:py-20">
        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Frequently asked questions</h2>
        <dl className="mt-10 space-y-8 divide-y divide-gray-900/10">
          {faqs.map((faq) => (
            <div key={faq.id} className="pt-8 lg:grid lg:grid-cols-12 lg:gap-8">
              <dt className="text-base font-semibold leading-7 text-gray-900 lg:col-span-5">{faq.question}</dt>
              <dd className="mt-4 lg:col-span-7 lg:mt-0">
                <p className="text-base leading-7 text-gray-600">{faq.answer}</p>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
        
    <FooterAts />
    </div>
    );
};

export default FAQ;